module.exports = __webpack_public_path__ + "media/featured_internships/marvel-logo-3b11e3ad.gif";